
import ServicePath from "@/core/ServicePath";
import { MainRequest } from "@/core/request";

export default class LaboratoryRequest extends MainRequest {

    static get(data){
        return this.postSEC(ServicePath.STUDY_LABORATORY_LIST_PARAMETERS_BY_STUDY, data)
    }
    static save(data){
        return this.postSEC(ServicePath.STUDY_LABORATORY_SAVE, data)
    }
    static update(data){
        return this.postSEC(ServicePath.STUDY_LABORATORY_UPDATE, data)
    }
}